import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Especialidades.css';

const Especialidades = () => {
  const [especialidades, setEspecialidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEspecialidades = async () => {
      try {
        const response = await axios.get('https://vortexcode.cl/api/especialidad');
        setEspecialidades(response.data);
      } catch (err) {
        setError('Hubo un error al cargar las especialidades');
      } finally {
        setLoading(false);
      }
    };
    fetchEspecialidades();
  }, []);

  // Función para codificar el nombre de la especialidad
  const encodeName = (name) => {
    return encodeURIComponent(name.trim()); // Codifica espacios como %20 y caracteres especiales
  };

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className='container'>
      <div id="especialidadesDestacadas">
        <h2 className="text-center mb-4">ESPECIALIDADES DESTACADAS</h2>

        <div id="especialidadesCarouselWrapper">
          <button
            id="especialidadesFlechaIzq"
            onClick={() => {
              document.querySelector("#especialidadesCarousel").scrollBy({ left: -200, behavior: "smooth" });
            }}
          >
            ❮
          </button>

          <div id="especialidadesCarousel">
            {especialidades.slice(0, 8).map(({ id_esp, img_especialidad, nombre_especialidad }, index) => (
              <Link
                key={id_esp}
                to={`/especialidad/${encodeName(nombre_especialidad)}`}
                className={`especialidadCard ${index === 1 ? 'active' : ''}`}
              >
                <div className="iconoEspecialidad" dangerouslySetInnerHTML={{ __html: img_especialidad }} />
                <p>{nombre_especialidad}</p>
              </Link>
            ))}
            <Link to="/especialidades" id="especialidadesVerTodo">Ver todo</Link>
          </div>

          <button
            id="especialidadesFlechaDer"
            onClick={() => {
              document.querySelector("#especialidadesCarousel").scrollBy({ left: 200, behavior: "smooth" });
            }}
          >
            ❯
          </button>
        </div>
      </div>
    </div>
  );
};

export default Especialidades;